<template>
    <div class="historical">
        <div v-html="content"></div>
    </div>
</template>

<script>
import { getRuleContent } from "@/api/expert";
export default {
    data() {
        return {
            content: "",
        };
    },
    methods: {
        async getRule(){
            const res = await getRuleContent({type:this.$route.query.type})
            if(res.appStatus.errorCode == 0){
                this.content = res.content.content;
            }
        }
    },
    mounted() {
        // switch (this.$route.query.type) {
        //     case '43':
        //         document.title = '行家端用户协议';
        //     break;
        //     case '44':
        //         document.title = '商家用户协议';
        //     break;
        //     case '45':
        //         document.title = '行家隐私政策';
        //     break;
        //     case '46':
        //         document.title = '行家操作手册';
        //     break;
        //     case '50':
        //         document.title = '关联小程序教程';
        //     break;
        // }
        
        // console.log(this.$route.query.type);
        this.getRule()
    },
    beforeRouteEnter(to, from, next) {
    if (from.path == "/e_registerAgreement") {
      let title;
      to.meta.hiddenHeader = false;
      switch (to.query.type) {
        case "43":
          title = "注册协议";
        break;
        case "45":
          title = "隐私政策协议";
        break;
        case "55":
          title = "喜豆说明";
        break;
        case "56":
          title = "喜豆兑换规则";
        break;
        case "58":
          title = "规则说明";
        break;
        default:
          break;
      }
      to.meta.title = title;
      document.title = title;
      // console.log(to,'1')
      // to.meta.hiddenHeader = false;
      // if (to.query.type == '26') {
      //   to.meta.title = "注册协议";
      // }else if(to.query.type == '25'){
      //   to.meta.title = "隐私政策协议"
      // }
    }
    next();
  },
};
</script>
<style lang='scss' scoped>
.historical {
  font-size: 16px;
  padding: 10px;
}
</style>